module.exports = __webpack_public_path__ + "static/img/vr1.d2e1ddb2.png";